function getSafeDate(value) {
  if (!value) {
    return new Date().toISOString();
  }

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return new Date().toISOString();
  }

  return parsedDate.toISOString();
}

export function slugify(value) {
  const slug = String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return slug || `note-${Date.now()}`;
}

export function estimateReadingTime(value) {
  const words = String(value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;

  if (!words) {
    return 1;
  }

  return Math.max(1, Math.round(words / 200));
}

export function normalizeTags(tags) {
  if (Array.isArray(tags)) {
    return tags.filter(Boolean).map(tag => String(tag).trim()).filter(Boolean);
  }

  return String(tags || "")
    .split(",")
    .map(tag => tag.trim())
    .filter(Boolean);
}

export function createEmptyBlogPost() {
  const timestamp = new Date().toISOString();
  const id = `draft-${Date.now()}`;

  return {
    id,
    slug: "",
    title: "",
    excerpt: "",
    content: "",
    coverImage: "",
    tags: [],
    status: "draft",
    createdAt: timestamp,
    updatedAt: timestamp,
    readingTime: 1,
    source: "custom"
  };
}

export function sortPostsByDate(posts) {
  return posts.slice().sort((firstPost, secondPost) => {
    const firstDate = new Date(firstPost.updatedAt || firstPost.createdAt).getTime();
    const secondDate = new Date(
      secondPost.updatedAt || secondPost.createdAt
    ).getTime();

    return secondDate - firstDate;
  });
}

export function formatBlogDate(value) {
  return new Date(getSafeDate(value)).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
